import { PermanentJobsApi } from '../clients';

export const publishDraftJobPost = async (id: string): Promise<void> => {
  await PermanentJobsApi.publishDraftJobPost(id);
};
